import { CreditReportingCompany } from './credit-report-transaction';

export interface CreditReportResponse {
  creditReferenceNumber?: string;
  lenderLoanNumber?: string;
  creditReportingCompany?: CreditReportingCompany;
  creditReportTotalCost?: number;
  borrowerCreditDetails?: BorrowerCreditDetails[];
  liabilityDetails?: LiabilityDetails;
  documents?: Document[];
  creditReportingAgency?: string;
}

export interface BorrowerCreditDetails {
  borrowerId?: string;
  creditScores?: CreditScore[];
  firstName?: string;
  lastName?: string;
}

export interface CreditScore {
  score?: number;
  creditBureau?: string;
  creditScoringModel?: string;
  scoreRankPercentile?: number;
}

export interface LiabilityDetails {
  liabilities?: Liability[];
  totals?: LiabilityTotal[];
}

export interface Liability {
  accountId?: string;
  accountType?: LiabilityAccountType;
  accountStatus?: LiabilityAccountStatus;
  accountOwnershipStatus?: LiabilityAccountOwnershipStatus;
  creditor?: string;
  monthlyPaymentAmount: number;
  unpaidBalanceAmount: number;
  associatedBorrowerIds?: string[];
}

export interface LiabilityTotal {
  accountType?: LiabilityAccountType;
  accountStatus?: LiabilityAccountStatus;
  totalMonthlyPaymentAmount: number;
  totalUnpaidBalanceAmount: number;
  count: number;
}

export interface Document {
  documentName?: string;
  documentContentType?: DocumentContentType;
  documentContent?: string;
}

export enum LiabilityAccountType {
  CreditLine = 'CreditLine',
  Installment = 'Installment',
  Mortgage = 'Mortgage',
  Open = 'Open',
  Revolving = 'Revolving',
  Unknown = 'Unknown',
}

export enum LiabilityAccountStatus {
  Closed = 'Closed',
  Frozen = 'Frozen',
  Open = 'Open',
  Paid = 'Paid',
  Refinanced = 'Refinanced',
  Transferred = 'Transferred',
}

export enum LiabilityAccountOwnershipStatus {
  AuthorizedUser = 'AuthorizedUser',
  Comaker = 'Comaker',
  Deceased = 'Deceased',
  Individual = 'Individual',
  JointContractualLiability = 'JointContractualLiability',
  JointParticipating = 'JointParticipating',
  Maker = 'Maker',
  OnBehalfOf = 'OnBehalfOf',
  Terminated = 'Terminated',
  Undesignated = 'Undesignated',
}

export enum DocumentContentType {
  Pdf = 'Pdf',
}
